import { useContext } from "react";
import { Context } from "@/shared/security/model/context-tokens/context";

export function useContextTokens() {
  return useContext(Context);
}
